

import "./Notes.scss"
import { ReactComponent as PlusButton } from "./assets/PlusButton.svg";
import { useGetNotesQuery } from "../../../../services/attendance-portal/notes.js"
import { Skeleton } from "primereact/skeleton";
import { format } from "date-fns";

import { useSelector } from "react-redux";
import { classNames } from "primereact/utils";
import { useToggle } from "../../../../hooks";
import { selectIsUserLoggedIn, selectUser } from "../../../login-page/LoginAuthSlice";
import Button from "../../../../components/prime-react-overrides/button/Button";
import { AddNotesModal } from "./add-notes/AddNotes";

const NotesText = ({ data }) => {
  
  const { content = "", heading, createdAt, image } = data;
  const [readMore, setReadMore] = useToggle(false);
  const notesLengthBool = content?.length > 75;
  const toDisplayText = readMore
    ? content
    : content?.substring(0, 75) + (notesLengthBool ? "..." : "");
  const viewHide = readMore ? "Hide" : "View More";

  return (
    <div className="mb-2 pt-2 pb-1 border-bottom-2 border-black-alpha-20">
      {image && (
        <div className="Image mb-2" style={{ backgroundImage: `url("${image}")`}}>
        </div>
      )}
      <div className="grid text-xs">
        <div className="col-1 Bullet ">
          <i
            className="pi pi-circle-fill"
            style={{ fontSize: "0.7rem" }}
          ></i>
        </div>
        <div className="col-11 text-white">
          {heading && <p className="m-0 text-base" style={{overflowWrap: 'break-word', lineHeight: '1rem'}}>{heading}</p>}
          <p className="m-0" style={{overflowWrap: 'break-word'}}>{toDisplayText}</p>
        </div>
      </div>
      <div className="flex ml-4 justify-content-between">
        <span
          className={classNames(` ViewMore text-xs opacity-0 pointer-events-none`, { "opacity-100 pointer-events-auto cursor-pointer": notesLengthBool })}
          onClick={() => notesLengthBool && setReadMore()}
        >
          {viewHide}
        </span>
        <span className="NotesDateText text-xs ">
          {format(new Date(createdAt), "EEE, d MMM yyyy")}
        </span>
      </div>
    </div>
  );
};

const Notes = () => {
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn)

  const { data: notesData = [], isLoading } = useGetNotesQuery(null, { skip: !isUserLoggedIn })
  const [showAddNotesModal, setShowAddNotesModal] = useToggle(false);

  const loggedInUser = useSelector(selectUser)


  const isSuperAdmin = loggedInUser?.isSuperAdmin ?? false;
  const addNotesPlusButton = (
    <Button icon={<PlusButton />} onClick={setShowAddNotesModal} className="p-button-rounded p-button-secondary p-button-outlined" aria-label="Bookmark" />

  );

  const skeletonNotes = (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="mb-4">
          <Skeleton height="1.5rem" className="SkeletonColor mb-2" />
          <Skeleton height="1rem" className="SkeletonColor mb-2" />
          <Skeleton height="1rem" className="SkeletonColor mb-2" />
        </div>
      ))}
    </>
  );

  const notesCondition =
    !isLoading && notesData && notesData?.length > 0 && (
      notesData.map(el => (
        <NotesText key={el._id} data={el} />
      ))
    )

  return (
    <div className="Notes px-3 h-full">

      <AddNotesModal visible={showAddNotesModal} onHide={setShowAddNotesModal} />

      <div className="flex justify-content-between align-items-center">
        <h3 className="text-white my-3 font-medium text-base md:text-lg">
          Notes for <span className="OrangeText font-bold">today!</span>
        </h3>
        {isSuperAdmin && addNotesPlusButton}
      </div>
      {isLoading ? skeletonNotes : notesCondition}
    </div>
  );
};

export default Notes;
